import { render, staticRenderFns } from "./Task_NewStudent.vue?vue&type=template&id=2990548f&scoped=true&"
import script from "./Task_NewStudent.vue?vue&type=script&lang=js&"
export * from "./Task_NewStudent.vue?vue&type=script&lang=js&"
import style0 from "./Task_NewStudent.vue?vue&type=style&index=0&id=2990548f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990548f",
  null
  
)

export default component.exports